import { Box, MenuItem, Stack, TextField, Typography } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import RepartionEspecesChequesRetrait from "./rep-especes-cheques-retrait";
import { fedVerseTypes } from "../../asset/variables";

export default function Step4(props) {
    const [repespeces, setRepEspeces] = useState(props.fedRepartition.especes)
    const [repCheque, setRepCheques] = useState(props.fedRepartition.cheques)
    const [retrait, setRetrait] = useState(props.fedRepartition.retrait)
    const [dispoMoney, setDispoMoney] = useState([])
    const dispoCheques = useMemo(()=>props.dons?.map(don=>don.repartition.cheques).flat(), [props.dons])
        
    const ttEspeces = useMemo(()=>repespeces.reduce((tt,esp)=>tt+esp.montant*esp.count,0),[repespeces])
    const ttRetrait = useMemo(()=>retrait.reduce((tt,esp)=>tt+esp.montant*esp.count,0),[retrait])
    const ttCheques = useMemo(()=>repCheque.reduce((tt,ch)=>tt+ch.montant,0),[repCheque])
    const total = useMemo(()=>ttEspeces+ttCheques+ttRetrait,[ttEspeces, ttCheques, ttRetrait])


    useEffect(()=>{
        setDispoMoney(()=>props.dispoMoney.map(money=>({
            ...money, 
            count: Number(money.count-(props.petiteCaisse.find(es=>es.montant===money.montant)?.count??0))
        })).filter(dm=>dm.count>0))
        props.setFedRepartition({especes:repespeces, cheques:repCheque, retrait})
    },[repespeces, repCheque, retrait])

    useEffect(()=>{
        const dispo = props.dispoMoney.map(money=>({
            ...money, 
            count: Number(money.count-(props.petiteCaisse.find(es=>es.montant===money.montant)?.count??0))
        })).filter(dm=>dm.count>0)
        setDispoMoney(dispo)
        setRepEspeces(dispo)
        setRepCheques(dispoCheques)
    }, [props.petiteCaisse, props.dispoMoney])

    return(
        <Box>
            <Typography variant="h6" align="center">Versement FEAM</Typography>
            <Typography variant="subtitle1" align="center">Le versement FEAM doit être d'une valeur supérieure ou égale à la recette fédérale qui s'élève à {props.fed_part.toFixed(2)}€</Typography>

            <Typography variant="subtitle1" marginTop={2} marginBottom={1}>{fedVerseTypes.find(fvt=>fvt.value===props.fedVerseType)?.label}</Typography>
            {!['virement', 'cheque'].includes(props.fedVerseType)&&<RepartionEspecesChequesRetrait  { ...{repespeces, setRepEspeces, dispoMoney, repCheque, setRepCheques, dispoCheques, retrait, setRetrait, eglise: props.eglise}}/>}

            {/* choix de la banque */}
            {props.fedVerseType==='banque'&&<Stack direction='row' spacing={2} alignItems='center' marginTop={2}>
                <Typography>Banque fédération:</Typography>
                <TextField select required size="small" sx={{width:'30%', minWidth:'250px'}} value={props.fedBanque} onChange={e=>props.setFedBanque(e.target.value)}>
                    {props.banqueComptes.map(cpt=><MenuItem key={cpt._id} value={cpt.num}>{cpt.banque}</MenuItem>)}
                </TextField>
            </Stack>}

            {/* recap totaux */}
            {props.fedVerseType!=='virement'&&<Stack direction='row' spacing={5} alignItems='center' justifyContent='center' marginTop={3}>
                {ttEspeces+ttRetrait>0&&<Typography variant="h6">Montant total espèce: {(ttEspeces+ttRetrait).toFixed(2)}€</Typography>}
                {dispoCheques.length>0&&<Typography variant="h6">Montant total chèque: {ttCheques.toFixed(2)}€</Typography>}
            </Stack>}
            <Typography variant="h6" fontWeight='bold' align="center">Montant total du versement: {total.toFixed(2)}€</Typography>
        </Box>
    )
}